// extracted by mini-css-extract-plugin
export default {"container":"authLayout_container__MZzB1","card":"authLayout_card__3uJFB","logo":"authLayout_logo__+55ZP"};